module.exports = __webpack_public_path__ + "static/media/project4.10961538.jpg";